var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoading = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 1c0-.552.449-1.005.998-.95a10 10 0 1 1-8.74 3.62c.35-.427.988-.424 1.378-.034s.385 1.02.046 1.457a8 8 0 1 0 7.315-3.03C10.45 1.992 10 1.552 10 1"
})));
export default SvgLoading;